<template>
    <div>
        <span v-if="timerOutput === null" class="blackText">-</span>
        <span v-else :class="countDownClass">{{ timerOutput }}</span>
    </div>
</template>
<style scoped></style>
<script setup>
    import { ref, onMounted, onBeforeUnmount } from 'vue';
    import { formatInTimeZone } from 'date-fns-tz';
    import { useAppStore } from '@/stores/app';

    const props = defineProps({
        fromTime: {
            type: String,
            default: null,
        },
        timeout: {
            type: [Number, null],
            default: null,
        },
        modelValue: {
            type: Number,
            default: 0,
        },
    });

    const appStore = useAppStore();

    const emit = defineEmits(['change']);

    const systemTimezone = 'Europe/London';
    const timerOutput = ref(null);
    const countDownClass = ref('');
    const intervalId = ref(null);

    const countDownToTime = ref(new Date(props.fromTime).getTime());

    const currentTime = () => {
        return new Date(formatInTimeZone(new Date(appStore.syncedDate()), systemTimezone, 'yyyy-MM-dd HH:mm:ss')).getTime();
    };

    const addLeadZero = (number) => {
        return String(number).padStart(2, '0');
    };

    const startTimer = () => {
        const timeNow = currentTime();
        const timeDifference = countDownToTime.value + props.timeout * 1000 - timeNow;

        emit('change', parseInt(timeDifference / 1000));

        if (timeDifference < 1000) {
            timerOutput.value = null;
            clearInterval(intervalId.value);
        } else {
            const millisecondsInOneSecond = 1000;
            const millisecondsInOneMinute = millisecondsInOneSecond * 60;
            const millisecondsInOneHour = millisecondsInOneMinute * 60;
            const millisecondsInOneDay = millisecondsInOneHour * 24;

            const differenceInDays = timeDifference / millisecondsInOneDay;
            const remainderDifferenceInHours = (timeDifference % millisecondsInOneDay) / millisecondsInOneHour;
            const remainderDifferenceInMinutes = (timeDifference % millisecondsInOneHour) / millisecondsInOneMinute;
            const remainderDifferenceInSeconds = (timeDifference % millisecondsInOneMinute) / millisecondsInOneSecond;

            const remainingDays = Math.floor(differenceInDays);
            const remainingHours = Math.floor(remainderDifferenceInHours);
            const remainingMinutes = Math.floor(remainderDifferenceInMinutes);
            let remainingSeconds = Math.floor(remainderDifferenceInSeconds);

            if (!remainingSeconds && (remainingMinutes || remainingHours || remainingDays)) {
                remainingSeconds = '00';
            }

            countDownClass.value = remainingDays || remainingHours ? 'big' : remainingMinutes ? 'medium' : 'small';

            timerOutput.value =
                (remainingDays ? remainingDays + 'd ' : '') +
                (remainingHours ? (remainingDays ? addLeadZero(remainingHours) : remainingHours) + 'h ' : '') +
                (remainingMinutes ? addLeadZero(remainingMinutes) + 'm ' : '') +
                (remainingSeconds && !remainingDays ? addLeadZero(remainingSeconds) + 's' : '');
            countDownToTime.value = countDownToTime.value + 1;
        }
    };

    onMounted(() => {
        console.log('Component %s mounted.', 'app-countdown');
        startTimer();
        intervalId.value = setInterval(() => {
            startTimer();
        }, 1000);
    });

    onBeforeUnmount(() => {
        if (intervalId.value) {
            clearInterval(intervalId.value);
        }
    });
</script>
